import { Box, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import colors from '../../constants/colors'
import { IProgressBar } from './types'

const mainContainer = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}

const progressContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: ' 100%',
  height: '20rem',
  position: 'relative',
}

const ProgressBar: React.FC<IProgressBar> = ({
  size = 0,
  externalProgress,
  setExternalProgress,
  themeColor = colors.TAG_PURPLE,
}) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    setProgress(0)
  }, [size])

  useEffect(() => {
    const timer = setInterval(() => {
      if (externalProgress !== undefined && setExternalProgress !== undefined) {
        setExternalProgress(prevProgress => (prevProgress >= 100 ? 100 : prevProgress + 4))
      }

      setProgress(prevProgress => (prevProgress >= 100 ? 100 : prevProgress + 4))
    }, 120)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <Box sx={[mainContainer]}>
      <Box sx={[progressContainerStyle]}>
        <Box>
          <Typography variant='boldTextXlarge' sx={{ color: themeColor }}>
            {progress} %
          </Typography>
        </Box>
        <CircularProgress
          variant='determinate'
          sx={{ color: themeColor, position: 'absolute' }}
          value={progress}
          size='14rem'
        />
      </Box>
      <Typography variant='bodyBold' sx={{ color: themeColor }}>
        Uploading File ...
      </Typography>
    </Box>
  )
}

export default ProgressBar
